import { render, staticRenderFns } from "./SlotBed.vue?vue&type=template&id=5a29c604&"
import script from "./SlotBed.vue?vue&type=script&lang=js&"
export * from "./SlotBed.vue?vue&type=script&lang=js&"
import style0 from "./SlotBed.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports